import * as React from 'react'

import LabelCountry from "../../LabelCountry";
import {Box} from "@mui/material";


export default function retailerWithCountryColumn() {
    return {
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { siteURL }) => <Box className={value === 'All' ? 'is-all' : ''}>
                <LabelCountry
				label={value}
				url={siteURL}
                />
            </Box>
        }
    }
}